// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UO9G","question":"styles_question__2MqN7","inputVisibleButton":"styles_inputVisibleButton__-Q9Ky","note":"styles_note__1Cz2y"};